module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "collection-image"
  }, [(_vm.image.type === 'image-360') ? _c('interactive-image', {
    attrs: {
      "id": _vm.image.src,
      "alt": _vm.image.alt
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.image.src,
      "alt": _vm.image.alt
    }
  }), _vm._v(" "), (_vm.hasTable) ? _c('div', {
    staticClass: "table vcenter-content h7 century-mono"
  }, [_c('div', {
    staticClass: "inner vcenter"
  }, [_c('h4', [_vm._v(_vm._s(_vm.image.table.header))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.image.table.text)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('figcaption', {
    domProps: {
      "innerHTML": _vm._s(_vm.setCaption(_vm.image))
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0e3477e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollectionImage.vue
// module id = 396
// module chunks = 1